import type { Action } from "../actions.types";

/**
 * Check if action is completed.
 */
export function isActionCompleted(action: Action): boolean {
  const statusName = action.current_status?.name?.toLowerCase();
  return statusName === "completed";
}

